import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import NewUserCouponRewardDialog from '@tencent/wphk-components-discount-code/components/new-user-coupon-reward/new-user-coupon-reward-dialog.vue';
import { useCouponRewardDialog } from './hooks/use-coupon-reward-dialog';
import { useBiReport } from './hooks/use-bi-report';
import { hideLoading, showLoading } from '@tencent/wphk-act-base-ui';
import { to } from '@tencent/wphk-base-utils';
import { useNewUserStore } from '@/store/new-user-module';
import { CustomException } from '@tencent/ppd-base-libs';
import { useErrorDialog } from './hooks/use-error-dialog';
import { toCouponDetailOrList } from '@tencent/wphk-components-discount-code/utils';
import { ScreenDialog } from '@tencent/wphk-ui';

// ---- DOM ref ----

export default /*#__PURE__*/_defineComponent({
  __name: 'coupon-reward-dialog',
  setup(__props) {

const couponDialog = ref<InstanceType<typeof ScreenDialog> | null>(null);

// ---- use hooks ----
const commonNewUserStore = useNewUserStore();
const {
  isCouponRewardDialogShow,
  hideCouponRewardDialog,
} = useCouponRewardDialog();
const { biReport } = useBiReport();
const { showDiscountCodeExecDialog } = useErrorDialog();

// ---- data ---
const couponInfo = computed(() => commonNewUserStore.couponModule.discountCodeCoupon);

// ---- 事件 ----
// 关闭弹层
function handleCloseRedeemCouponDialog() {
  biReport('dialog_close');
  hideCouponRewardDialog();
};
// 领券
async function handleRedeemCoupon() {
  // 运营活动-迎新奖赏-全城狂赏主页-确认领取弹窗确认领取点击
  biReport('confirmpopup_confirmbtn_click');
  showLoading();
  const [err] = await to(commonNewUserStore.execAct());
  hideLoading();

  if (err) {
    showDiscountCodeExecDialog(err);
    throw new CustomException(
      null,
      'WelcomeOfferhandleReceiveFail',
      `领取优惠码失败:${err.name}`,
    );
  }
  // 运营活动-迎新奖赏-全城狂赏主页-领取成功弹窗曝光
  biReport('successpopup_brow');
};

// 去使用
function handleViewCouponInDialog() {
  // 运营活动-迎新奖赏-全城狂赏主页-领取成功弹窗查看优惠券点击
  biReport('successpopup_viewcoupons_click');
  setTimeout(() => {
    couponDialog.value?.hide();
  }, 300);
  // 领取成功弹窗[查看优惠券]按钮：查看跳列表或者券详情
  return toCouponDetailOrList(couponInfo.value, 'channel');
};

return { __sfc: true,couponDialog, commonNewUserStore, isCouponRewardDialogShow, hideCouponRewardDialog, biReport, showDiscountCodeExecDialog, couponInfo, handleCloseRedeemCouponDialog, handleRedeemCoupon, handleViewCouponInDialog, NewUserCouponRewardDialog }
}

})